export const smallScreen = window.matchMedia('(max-width: 640px)').matches;
export const mediumScreen = window.matchMedia('(max-width: 768px)').matches;
export const largeScreen = window.matchMedia('(max-width: 1024px)').matches;
export const extraLargeScreen = window.matchMedia(
  '(max-width: 1280px)',
).matches;
export const extraExtraLargeScreen = window.matchMedia(
  '(max-width: 1536px)',
).matches;
